var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExamooMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "76.9px",
    height: "44.6px",
    viewBox: "0 0 76.9 44.6",
    enableBackground: "new 0 0 76.9 44.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M57.8,0H19c-6,0-11,4.9-11,11v22.6c0,6,4.9,11,11,11h38.8c6,0,11-4.9,11-11V11C68.8,4.9,63.9,0,57.8,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EF3633",
    d: "M38.4,32c-0.6,0-1.2-0.2-1.7-0.5L1.8,10.3C0.1,9.3-0.5,7,0.4,5.2c0.9-1.8,3.1-2.5,4.8-1.5l34.9,21.2 c1.7,1,2.3,3.3,1.3,5.2C40.8,31.3,39.6,32,38.4,32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF3633",
    d: "M38.5,32c-1.2,0-2.4-0.7-3.1-1.9c-0.9-1.8-0.3-4.1,1.3-5.2L71.7,3.7c1.7-1,3.8-0.4,4.8,1.5s0.3,4.1-1.3,5.2 L40.2,31.5C39.6,31.9,39,32,38.5,32z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamooMail);
export default __webpack_public_path__ + "static/media/examoo-mail.19980582019f2caf6635404caad5eeda.svg";
export { ForwardRef as ReactComponent };